import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const ANDREEA_PHOTO = 'https://cdn.magicpatterns.com/uploads/9gj5iqrEkvf8RHnMKQ6fGs/poza1.jpg';
export function HeroSection() {
  return <section className="bg-navy diagonal-pattern py-20 px-6 relative overflow-hidden" data-id="element-91">
      <div className="max-w-7xl mx-auto" data-id="element-92">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-93">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-94">
            <div className="text-gold font-label text-xs uppercase tracking-label mb-6" data-id="element-95">
              AVOCAT · DREPTUL FAMILIEI
            </div>

            <h1 className="text-text-light font-heading text-5xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-96">
              Din frică și blocaj, la{' '}
              <span className="text-gold" data-id="element-97">claritate juridică</span> și un nou
              început.
            </h1>

            <p className="text-text-light-secondary font-body text-lg leading-relaxed mb-8" data-id="element-98">
              Ajut oamenii care traversează un divorț, un partaj sau o moștenire
              dificilă să înțeleagă exact ce drepturi au, să-și protejeze copiii
              și să obțină rezultate clare în instanță, fără surprize pe
              parcurs.
            </p>

            <div className="space-y-4" data-id="element-99">
              <Link to="/contact" className="inline-block bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-100">
                Rezervă Sesiunea de Claritate
              </Link>
              <p className="text-text-light-secondary font-body text-sm" data-id="element-101">
                Sesiunea de 150 EUR + TVA se aplică integral la pachetul ales
                dacă decizi să continuăm.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex justify-center" data-id="element-102">
            <div className="relative" data-id="element-103">
              {/* Emerald blob */}
              <div className="absolute -inset-8 bg-emerald/15 rounded-[30%_70%_70%_30%/30%_30%_70%_70%] blur-sm" data-id="element-104"></div>

              {/* Decorative gold circles */}
              <div className="absolute -top-4 -right-4 w-24 h-24 border border-gold/30 rounded-full z-0" data-id="element-105"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-gold/20 rounded-full z-0" data-id="element-106"></div>
              <div className="absolute top-1/2 -right-8 w-16 h-16 border border-gold/15 rounded-full z-0" data-id="element-107"></div>

              {/* Decorative gold dots */}
              <div className="absolute -top-2 left-8 w-2 h-2 bg-gold/40 rounded-full z-0" data-id="element-108"></div>
              <div className="absolute bottom-12 -right-3 w-3 h-3 bg-gold/30 rounded-full z-0" data-id="element-109"></div>
              <div className="absolute top-20 -left-4 w-2.5 h-2.5 bg-gold/25 rounded-full z-0" data-id="element-110"></div>

              {/* Vertical emerald accent line */}
              <div className="absolute -left-6 top-8 bottom-8 w-[2px] bg-emerald/30 z-0" data-id="element-111"></div>

              <div className="relative gold-corner-frame" data-id="element-112">
                <img src={ANDREEA_PHOTO} alt="Andreea Saveli - Avocat Dreptul Familiei" className="relative z-10 w-96 h-[480px] object-cover object-top rounded-lg shadow-2xl shadow-navy/50" data-id="element-113" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}